<template>
<header class="header-global">
  <base-nav class="navbar-main" transparent type="" effect="light" expand>
  <router-link slot="brand" :to="{ name: 'home' }" class="navbar-brand mr-lg-5">
      <img src="./../assets/img/ao_spine_white_rgb.png">
  </router-link>
    <div class="row" slot="content-header" slot-scope="{closeMenu}">
      <div class="col-6 collapse-brand">
      <router-link :to="{ name: 'home'}" >
          <img src="./../assets/img/ao_spine_white_rgb.png">
      </router-link>
      </div>
      <div class="col-6 collapse-close">
        <close-button @click="closeMenu"></close-button>
      </div>
    </div>
     <ul class="navbar-nav ml-lg-auto">
      <li class="nav-item">
          <router-link :to="{ name: 'home'}" class="nav-link nav-link-icon">HOME</router-link>
      </li>
      <li class="nav-item">
               <router-link :to="{ name: 'about'}" class="nav-link nav-link-icon">ABOUT</router-link>
      </li>
      <base-dropdown tag="li" title="LINKS">
        <a class="dropdown-item" target="_blank" href="https://www.aolatam.org/ftp/news-index/">Newsletter</a>
        <a class="dropdown-item" target="_blank" href="https://aosla.com.br/report2021/">Annual Report</a>
        <a class="dropdown-item" target="_blank" href="https://www.aolatam.org/ftp/downloads/">Downloads</a>
        <a class="dropdown-item" target="_blank" href="https://surgeryreference.aofoundation.org">AO Surgery Reference</a>
        <a class="dropdown-item" target="_blank" href="https://www.aolatam.org/ftp/cep/">CEP Postgraduation</a>
        <a class="dropdown-item" target="_blank" href="https://aosla.com.br/fellows/">Fellowships</a>

      </base-dropdown>
      <li class="nav-item">
               <router-link :to="{ name: 'faq'}" class="nav-link nav-link-icon">FAQ</router-link>
      </li>
      <li class="nav-item">
        <router-link :to="{ name: 'contact'}" class="nav-link nav-link-icon">CONTACT</router-link>
      </li>
      <li class="nav-item" v-tooltip.bottom="{ content:'For internal use only', offset: 0, class: 'navbar-custom' }">
        <a href="http://web.aosla.com.br/" class="nav-link nav-link-icon">LOGIN</A>
      </li>
    </ul>
  </base-nav>
</header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>
<style>
/* Atualização chamado #5491*/
@import url('https://fonts.googleapis.com/css?family=Open+Sans&display=swap');
*, html, body,h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
  font-family: "Open Sans",sans-serif;
}
.navbar-brand img {
    height: 60px!important;
}
.btn-warning {
  background-color: #FFF500!important;
  border-color: #FFF500!important;
  color: #042d98!important;
}
.btn-primary {
  background-color: #3B7FF6!important;
  border-color: #3B7FF6!important;  
}
.btn-outline-primary:hover {
  color: #fff!important;
  background-color: #3B7FF6!important;
}
.btn-outline-primary {
  color: #3B7FF6!important;
  border-color: #3B7FF6!important;
}
.nav-pills .nav-link.active, .nav-pills .show>.nav-link {
  background-color: #3B7FF6!important;  
}
.card-header {
  background-color: #EDF0F6 !important;
  /*color: #000000;*/
}
.card-footer:last-child {
  background-color: #EDF0F6 !important;  
}
.vdp-datepicker__calendar .cell.selected {
  color: #fff!important;
  background: #3B7FF6!important;;
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
  border: 1px solid #3B7FF6!important;
}
.text-primary {
  color: #042D98!important;
}
.text-success {
  color: #6EB43C!important;
}
.text-danger {
  color: #D0021B!important;
}
.text-default {
  color: #333333!important;
}
.btn-success {
  background-color: #6EB43C!important;
  border-color: #6EB43C!important;
}
.btn {
  -webkit-border-radius: 50rem!important;
-moz-border-radius: 50rem!important;
border-radius: 50rem!important;
}
.vue-tooltip {
  background-color: #FFF500!important; 
  color: #042d98!important;
  font-size: 0.75rem;
}
.tooltip-arrow {
  border-bottom-color: #FFF500!important;  
}
.tooltip-content {
  background-color: #FFF500!important;  
  border-color: #FFF500!important;  
}
.vue-tooltip.navbar-custom {
  margin-top: -15px !important;
}
/*Controlando fonte dos itens do menu e do dropdown*/
.navbar-nav .nav-link-icon,
.navbar-nav .nav-link {
  font-size: 1rem;
}
.nav-link i:not(.fa) {
  margin-right: 0;
}
@media (min-width: 768px) {
  .navbar-transparent .navbar-nav .nav-link:hover, .navbar-transparent .navbar-nav .nav-link:focus {
      color: #FFF500!important;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-left: 0.5rem;
    /*padding-right: 0.5rem;*/
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/AppHeader.vue